/* eslint-disable react/prop-types */
import React from 'react';

// Children is a prop passed automatically by react to pass down components inside other components
export default function InputWrapper({ title, note, optional, error, children }) {
  return(
    <div className={`input-wrapper ${error ? 'input-wrapper-error' : ''}`}>
      <span className="input-wrapper-title">{title}</span> {optional && <span className="input-wrapper-optional">(opcional)</span>}
      {note && <span className="input-wrapper-note">{note}</span>}
      {children}
      {error &&
        <>
          <div style={{ marginTop: '5px' }}/>
          <label className="input-wrapper-error-text">{error}</label>
        </>
      }
    </div>
  );
}